import { xorWith, isEmpty, isEqual } from 'lodash';

/**
 * Using lodash functions to determine if two arrays are the same.
 *
 * Returns the result of isEmpty on the return value of invoking isEqual as the comparator in
 * xorWith to retrieve the values that aren't in the one array or the other
 */
const isArrayEqual = (
  firstArray: Array<number | string | object>,
  secondArray: Array<number | string | object>
): boolean => isEmpty(xorWith(firstArray, secondArray, isEqual));

export default isArrayEqual;
